var _path, _circle, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 144,
    viewBox: "0 0 137 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.6269 67.1605L110.116 84.467L104.338 90.1859L86.8531 72.8755C80.3473 78.0376 72.2552 80.8452 63.917 80.8335C43.631 80.8335 27.167 64.5375 27.167 44.4585C27.167 24.3795 43.631 8.0835 63.917 8.0835C84.203 8.0835 100.667 24.3795 100.667 44.4585C100.679 52.7116 97.8422 60.7211 92.6269 67.1605ZM84.4357 64.1616C89.618 58.8868 92.512 51.8161 92.5003 44.4585C92.5003 28.8253 79.7072 16.1668 63.917 16.1668C48.1227 16.1668 35.3337 28.8253 35.3337 44.4585C35.3337 60.0876 48.1227 72.7502 63.917 72.7502C71.3504 72.7618 78.494 69.8972 83.8232 64.7679L84.4357 64.1616Z",
    fill: "#D9D9D9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2079,
    cy: 129.736,
    r: 12.2079,
    fill: "#D9D9D9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.5713,
    y: 117.528,
    width: 103.428,
    height: 10.1733,
    rx: 5.08664,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33.5713,
    y: 133.127,
    width: 79.0125,
    height: 10.1733,
    rx: 5.08664,
    fill: "#D9D9D9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.4262578b6c0b125dcc03c7fd17ae80ff.svg";
export { ForwardRef as ReactComponent };